module.exports = __webpack_public_path__ + "img/small-2.7b3d1ccd.jpg";